$(document).ready(function(){
    $('.mfclogos').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3500,
        arrows: true,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        dots: false,
        pauseOnHover: true,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 1
            }
        }]
    });
});

//=include ./snippets/_slider_news.js
//Data Table in every table
/* =============================================== */
$(document).ready(function() {
    $('.table').DataTable({
      paging: false,
      searching: false
    });
} );

$('.accordion').on('shown.bs.collapse', function(e){
   $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
});
$('.collapse').on('shown.bs.collapse', function(e){
   $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
});

$(document).ready(function() {
  var table = $('table.display').DataTable({
    responsive: true,
    rowReorder: {
      selector: 'td:nth-child(2)'
    },

  });
});

//Go To Top
/* =============================================== */
$(document).ready(function() {
  $("#go-top").hide();
  $(function() {
    $(window).scroll(function() {
      if ($(this).scrollTop() > 50) {
        $('#go-top').fadeIn();
      } else {
        $('#go-top').fadeOut();
      }
    });
    $('#go-top a').click(function() {
      $('body,html').animate({
        scrollTop: 0
      }, 800);
      return false;
    });
  });
});

//Fancybox
/* =============================================== */
	$(document).ready(function() {
		$(".fancybox").fancybox({
			openEffect	: 'none',
			closeEffect	: 'none'
		});
	});

//Dotdotdot
/* =============================================== */
$(document).ready(function() {
  $(".ellipsis").dotdotdot({
    watch: "window",
    ellipsis: "...",
    wrap: "word",
    fallbackToLetter: false,
    height: 80,
    lastCharacter: {
      remove: [" ", ",", ";", ".", "!", "?"],
      noEllipsis: []
    }
  });
  $(".h-ellipsis").dotdotdot({
    watch: "window",
    ellipsis: "...",
    wrap: "word",
    fallbackToLetter: false,
    height: 60,
    lastCharacter: {
      remove: [" ", ",", ";", ".", "!", "?"],
      noEllipsis: []
    }
  });

});

